import React from "react";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import cx from 'classnames';
import { injectIntl } from "react-intl";
import { Container } from "react-bootstrap";
import EditProfileForm from "../../components/EditProfileForm/EditProfileForm";
import userAccount from "./getUserDetails.graphql"
import useQueryResponse from "../../lib/hooks/useQueryResponse";

const Profile = () => {
    const { data, loading } = useQueryResponse({
        query: userAccount,
        ssr: true,
        fetchPolicy: 'netWork-only'
    })
    let initialValues = {
        firstName: data?.userAccount?.result?.firstName,
        lastName: data?.userAccount?.result?.lastName,
        location: data?.userAccount?.result?.address
    }
    const referralCode = data?.userAccount?.result?.referralCode;
    return (
        <div className={cx('subPageContainer')}>
            <Container>
                <div className='subPageWrapper'>
                    <ProfileCard />
                    <EditProfileForm initialValues={initialValues} referralCode={referralCode} />
                </div>
            </Container>
        </div>
    )

}
export default injectIntl(Profile)